import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Bootstrap CSS + JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Boxicons
import 'boxicons/css/boxicons.min.css';

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from './authConfig';
import { AuthProvider } from './contexts/AuthContext';


const theme = createTheme({
  palette: {
    mode: 'light',
  },
});
msalInstance.initialize().then(() => {
  createRoot(document.getElementById('root')).render(
    // <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </MsalProvider>
    //</StrictMode>
  )
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
